<template>
    <div>
        <h6>
            {{ $t('Component(CoveredLegislations):label') }}

        </h6>
        <b-list-group>
            <b-list-group-item v-for="legislation in legislations">
                {{ legislation.title }}
                <InstructionInfoButton
                    v-if="hasTranslations(legislation)"
                    class="pl-1"
                    :instruction="instruction(legislation)"
                    :title="title(legislation)"
                />
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'
import InstructionInfoButton from "@core/components/common/instructions/InstructionInfoButton";

export default {
    components: {
        BListGroup, BListGroupItem, InstructionInfoButton
    },
    props: {
        legislations: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    methods: {
        title(legislation) {
            return this.$t('Component(IButton):legislation-title-' + legislation.key);
        },
        instruction(legislation) {
            return this.$t('Component(IButton):legislation-instruction-' + legislation.key);
        },
        hasTranslations(legislation) {
            return this.isTranslationSet('Component(IButton):legislation-title-' + legislation.key)
                || this.isTranslationSet('Component(IButton):legislation-instruction-' + legislation.key);
        },

        isTranslationSet(key) {
            const translation = this.$t(key);

            return translation !== key && translation.length > 0;
        }
    }
}
</script>
